<div class="flex flex-1 flex-col items-center justify-center text-white w-full">
  <div class="text-lg font-semibold flex flex-1 flex-row items-center justify-center text-white w-full">
    Horarios de atención
  </div>
  <div class="flex flex-1 flex-row items-center justify-center text-white w-full">
    Dorrego 881
  </div>
  <div class="flex flex-1 justify-start space-x-2 items-center">
    <span class="text-sm text-white mobile:text-xs">Lunes a Viernes</span>
  </div>
  <div class="flex flex-1 justify-start space-x-2 items-center">
    <span class="text-base text-white">09:00 hs. a 17:00 hs.</span>
  </div>
  <!-- <div class="flex flex-1 justify-start space-x-2 items-center">
    <button
      class="text-white hover:text-primary-700 bg-primary-700 hover:bg-white focus:ring-4 focus:ring-primary-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2"
      type="button" data-modal-toggle="default-modal">
      Ver más
    </button>
  </div> -->
</div>



<!-- Main modal -->
<div id="default-modal" aria-hidden="true"
  class="hidden overflow-y-auto overflow-x-hidden fixed right-0 left-0 top-4 z-50 justify-center items-center h-modal md:h-full md:inset-0">
  <div class="relative px-4 w-full max-w-2xl h-full md:h-auto">
    <!-- Modal content -->
    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
      <!-- Modal header -->
      <div class="flex justify-between items-start p-5 rounded-t border-b dark:border-gray-600">
        <h3 class="text-xl font-semibold text-black lg:text-2xl dark:text-white">
          Horarios de Sedes
        </h3>
        <button type="button"
          class="text-black bg-transparent hover:bg-gray-200 hover:text-black rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
          data-modal-toggle="default-modal">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"></path>
          </svg>
        </button>
      </div>
      <!-- Modal body -->
      <div class="p-6 space-y-6">
        <p class="text-base leading-relaxed text-black dark:text-black">
          Sede 1 - Lunes a Viernes --- 09:00hs. a 17:00hs.
        </p>
      </div>
    </div>
  </div>
</div>
